import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import { Formik, Form } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { currentTenant, userid } from "../../Common/Credentials";
import InventoryService from "../InventoryService";
import { Spinner } from "react-bootstrap";
import dayjs from "dayjs";

import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'

const NewInternalconsumption = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [BatchList, setBatchList] = useState([]);
  const [batchid, setBatchid] = useState("");
  const [customid, setCustomId] = useState("");
  const [stock, setStock] = useState("");
  const [item, setItem] = useState("");
  const [date, setDate] = useState(dayjs());
  const [avlquantity, setAvlquantity] = useState(0);
  const [description, setDescription] = useState('');
  const [wid, setWid] = useState("");
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    InventoryService.getinternalconsumptionstock(currentTenant)
      .then((res) => setBatchList(res.data.sort((a, b) => (a.id < b.id ? 1 : -1))));
  }, []);

  const handlebatchchange = (event, newValue) => {
    if (newValue && typeof newValue === "object") {
      setBatchid(newValue.id);
      setCustomId(newValue.customid);
      setAvlquantity(newValue.totalstock);
      setItem(newValue.item);
      setWid(newValue.wid);
    } else {
      setBatchid("");
      setCustomId("");
      setAvlquantity(0);
      setItem("");
      setWid("");
    }
  };

  const handleDateChange = (d) => {
    setDate(d);
  };

  const onSubmit = () => {
    if (stock <= avlquantity) {
      const data = {
        batchid: batchid,
        stock: stock,
        date: date,
        wid: wid,
        description: description,
        createdby: userid,
        updatedby: userid,
        tenantid: currentTenant
      };
      setLoading(true);
      InventoryService.AddInternalConsumption(data)
        .then(() => navigate(-1))
        .catch(() => setLoading(false));
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!batchid) {
      errors.batchid = 'Please select a Batch';
    }
    if (stock === undefined || stock === "" || stock === null) {
      errors.stock = 'Please enter quantity';
    } else if (parseFloat(stock) > avlquantity) {
      errors.stock = 'Quantity Exceeds';
    } else if (parseFloat(stock) <= 0) {
      errors.stock = 'Please Enter Positive Quantity';
    }
    return errors;
  };

  return (
    <div>

      <Header />
      <Menu />
      <div className="content-wrapper">
        {loading && (
          <div className="UI-loading-overlay">
            <div className="UI-spinner"></div>
          </div>
        )}

        <div className="UI-container">
          <div className="UI-card">
            <div className="UI-header">
              <nav className="UI-breadcrumb">
                <Link
                  to="/inventory"
                  className={`UI-breadcrumb-item ${hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                  onMouseEnter={() => setHovered('home')}
                  onMouseLeave={() => setHovered(null)}
                >
                  Home
                </Link>
                <span>/</span>
                <span className="UI-breadcrumb-active">Internal Consumption</span>
              </nav>

              <div className="UI-header-content">
                <div>
                  <h1 className="UI-title">Internal Consumption</h1>
                  <p className="UI-subtitle">Record consumption of items for internal use</p>
                </div>
                <div className="UI-header-actions">
                  <button
                    onClick={() => navigate(-1)}
                    className={`UI-btn UI-btn-outline ${hovered === "back" ? "UI-btn-outline-hover" : ""}`}
                    style={{
                      backgroundColor: hovered === "back" ? "#4d4d4d" : "#ffffff",
                      color: hovered === "back" ? "#fff" : "#4d4d4d",
                      transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                      border: '1px solid #4d4d4d',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={() => setHovered("back")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    ← Back
                  </button>
                </div>
              </div>
            </div>

            <div className="UI-form-container">
              <Formik
                initialValues={{}}
                onSubmit={onSubmit}
                validateOnChange={false}
                validate={validate}
                enableReinitialize
              >
                {({ errors }) => (
                  <Form autoComplete="off">
                    <div className="UI-form-section">
                      <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>
                        Consumption Details
                      </h3>

                      <div className="UI-form-grid">
                        {/* Batch Selection */}
                        <div className="UI-form-group">
                          <label className="UI-label">Batch *</label>
                          <Autocomplete
                            options={BatchList}
                            getOptionLabel={(option) => `${option.customid} (${option.item})`}
                            value={BatchList.find(b => b.id === batchid) || null}
                            onChange={handlebatchchange}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  {...params.inputProps}
                                  className={`UI-input ${errors.batchid ? 'UI-input-error' : ''}`}
                                  placeholder="Select batch"
                                />
                              </div>
                            )}
                          />
                          {batchid && (
                            <div className="UI-helper-text">Available stock: {avlquantity}</div>
                          )}
                          {errors.batchid && <div className="UI-error-text">{errors.batchid}</div>}
                        </div>

                        {/* Item (read-only) */}
                        <div className="UI-form-group">
                          <label className="UI-label">Item/Product</label>
                          <input
                            type="text"
                            className="UI-input UI-input-disabled"
                            value={item}
                            disabled
                          />
                        </div>

                        {/* Quantity */}
                        <div className="UI-form-group">
                          <label className="UI-label">Consumed Quantity *</label>
                          <input
                            type="number"
                            className={`UI-input ${errors.stock ? 'UI-input-error' : ''}`}
                            value={stock}
                            onChange={(e) => setStock(e.target.value)}
                            min="0"
                            step="0.01"
                          />
                          {errors.stock && <div className="UI-error-text">{errors.stock}</div>}
                        </div>

                        {/* Date - Fixed with MUI X v5 API */}
                        <div className="UI-form-group">
                          <label className="UI-label">Consumption Date</label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={date}
                              onChange={handleDateChange}
                              maxDate={dayjs()}
                              format="DD/MM/YYYY"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  className="UI-input"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        {/* Description */}
                        <div className="UI-form-group" style={{ gridColumn: 'span 4' }}>
                          <label className="UI-label">Description/Specifications</label>
                          <textarea
                            className="UI-textarea"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter description (optional)"
                            rows="2"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="UI-btn-actions">
                      <Link
                        to="/inventory"
                        className={`UI-btn UI-btn-outline ${hovered === "cancel" ? "UI-btn-outline-hover" : ""}`}
                        style={{
                          backgroundColor: hovered === "cancel" ? "#4d4d4d" : "#ffffff",
                          color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                          transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                          border: '1px solid #4d4d4d',
                          textDecoration: 'none',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={() => setHovered("cancel")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        disabled={loading}
                        className={`UI-btn UI-btn-primary ${hovered === "submit" ? "UI-btn-primary-hover" : ""}`}
                        style={{
                          opacity: loading ? 0.6 : 1,
                          transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                        }}
                        onMouseEnter={() => setHovered("submit")}
                        onMouseLeave={() => setHovered(null)}
                      >
                        {loading ? <><Spinner animation="border" size="sm" /> Saving...</> : 'Save'}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewInternalconsumption;